parseOperationDefinition